import { useState, useRef } from "react";
import { MoveHorizontal } from "lucide-react";

// A draggable before/after image reveal slider.
export default function BeforeAfter({ before, after, beforeLabel = "The napkin", afterLabel = "The build" }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <div
      ref={ref}
      data-testid="before-after"
      className="relative aspect-video w-full select-none overflow-hidden border border-border bg-[#050a16]"
      onMouseMove={(e) => dragging.current && move(e.clientX)}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
    >
      {/* after (full) */}
      <img src={after} alt={afterLabel} className="absolute inset-0 h-full w-full object-cover" draggable={false} />
      <span className="absolute right-3 top-3 border border-border bg-background/80 px-2.5 py-1 font-mono2 text-[10px] uppercase tracking-widest text-primary backdrop-blur">
        {afterLabel}
      </span>

      {/* before (clipped) */}
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={beforeLabel}
          className="absolute inset-0 h-full w-full object-cover"
          style={{ width: ref.current ? ref.current.getBoundingClientRect().width : "100%", maxWidth: "none" }}
          draggable={false}
        />
        <span className="absolute left-3 top-3 border border-border bg-background/80 px-2.5 py-1 font-mono2 text-[10px] uppercase tracking-widest text-foreground backdrop-blur">
          {beforeLabel}
        </span>
      </div>

      {/* handle */}
      <div
        className="absolute top-0 z-10 flex h-full w-0.5 cursor-ew-resize items-center justify-center bg-primary"
        style={{ left: `${pos}%` }}
        onMouseDown={() => (dragging.current = true)}
        onTouchStart={() => (dragging.current = true)}
        data-testid="before-after-handle"
      >
        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-primary text-black shadow-lg">
          <MoveHorizontal className="h-4 w-4" />
        </div>
      </div>
    </div>
  );
}
